import { selectScorecardView } from '../ceoCockpitModel'
import type { CeoBasisKind, CeoCockpitResponse, CeoPeriodKind } from '../ceoCockpitTypes'
import { StatTile } from './StatTile'

export function CeoScorecard({
  payload,
  period,
  basis,
  onExplainMetric,
}: {
  payload: CeoCockpitResponse
  period: CeoPeriodKind
  basis: CeoBasisKind
  onExplainMetric?: (metricId: string) => void
}) {
  const tiles = selectScorecardView(payload, period)
  const window = payload.calendar[period]
  const ribbon = `Day ${window.days_elapsed} of ${window.days_in_period} · ${Math.round(window.calendar_fraction * 100)}% of ${window.label.replace(' to date', '')} elapsed`
  return (
    <section className="ceo-section rise" id="ceo-scorecard">
      <p className="ceo-kicker">Scorecard</p>
      <div className="ceo-scorecard">
        {tiles.map(({ metric, block }) => (
          <StatTile
            key={metric.id}
            metric={metric}
            block={block}
            basis={basis}
            elapsedLabel={ribbon}
            onExplain={onExplainMetric ? () => onExplainMetric(metric.id) : undefined}
          />
        ))}
      </div>
      <p className="ceo-pace-ribbon">{ribbon}</p>
    </section>
  )
}
